var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_324_244",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 25,
  height: 25
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.943359,
  y: 0.0615234,
  width: 24,
  height: 24,
  fill: "currentColor"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_324_244)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.94336 21.0615C5.39336 21.0615 4.92253 20.8657 4.53086 20.474C4.13919 20.0824 3.94336 19.6115 3.94336 19.0615V5.06152C3.94336 4.51152 4.13919 4.04069 4.53086 3.64902C4.92253 3.25736 5.39336 3.06152 5.94336 3.06152H12.9434V5.06152H5.94336V19.0615H12.9434V21.0615H5.94336ZM16.9434 17.0615L15.5684 15.6115L18.1184 13.0615H9.94336V11.0615H18.1184L15.5684 8.51152L16.9434 7.06152L21.9434 12.0615L16.9434 17.0615Z",
  fill: "currentColor"
}))));
export default SvgLogout;